import { type JSX, type ReactNode } from 'react';
import { useSelector } from 'react-redux';

import { useApplicationContext } from '@/app/shared/context/ApplicationContext';
import { useGetCianAnalyticsPageViewObject } from '@/app/shared/hooks/useGetCianAnalyticsPageViewObject';

import { Listing } from '@/microfrontends/listing/shared';

import { Map } from '@/microfrontends/map/shared';

import { useReduxSelector } from '@/packages/redux-state/store';
import { selectComparisonNotificationState } from '@/packages/redux-state/store/slices/comparisonNotification/selectors/selectComparisonNotificationState';
import { isCommercialSelector } from '@/packages/redux-state/store/slices/jsonQuery/selectors/isCommercialSelector';
import { useListingLayoutIsNarrowSelector } from '@/packages/redux-state/store/slices/listingLayout/selectors/dumb';

import { AdfoxSEOBottomBannersLoadable } from '../../components/AdfoxSEOBottomBanners/AdfoxSEOBottomBannersLoadable';
import { ChatPopupContainer } from '../../components/ChatPopup';
import { ComparisonNotificationContainerLoadable } from '../../components/ComparisonNotification';
import { CrosslinksContainer } from '../../components/Crosslinks';
import { Filters } from '../../components/Filters';
import { MarkedListContainer } from '../../components/MarkedList';
import { RenderInViewPort } from '../../components/RenderInViewPort';
import { TopHitsLinksContainer } from '../../components/TopHitsLinks';
import { MapLayoutContainer } from '../MapLayoutContainer';

import { Layout } from './internal/components/Layout';

export function PageContainer(): ReactNode {
  const context = useApplicationContext();
  const isMapOpen = useListingLayoutIsNarrowSelector();
  const isCommercial = useReduxSelector(isCommercialSelector);
  const { comparisonNotification } = useSelector(selectComparisonNotificationState);

  /**
   * @todo Удалить RSку
   * @description Данный функционал появился в задаче CD-173365, будет удалён в задаче CD-173955
   */
  const listingMapEnabled = context.config.getStrict<boolean>('search-frontend.NewListingMap.Enabled');
  const getPageView = useGetCianAnalyticsPageViewObject();

  return (
    <Layout>
      <Filters />
      {listingMapEnabled ? (
        <Layout.SectionWithMap
          isMapOpen={isMapOpen}
          isNarrow={isMapOpen}
          isResponsive={!isCommercial}
          map={<MapLayoutContainer map={<Map context={context} />} />}
        >
          <Listing context={context} getPageView={getPageView} />
          <ChatPopupContainer />
          {comparisonNotification && <ComparisonNotificationContainerLoadable notification={comparisonNotification} />}
        </Layout.SectionWithMap>
      ) : (
        <Layout.Section>
          <Listing context={context} getPageView={getPageView} />
          <ChatPopupContainer />
          {comparisonNotification && <ComparisonNotificationContainerLoadable notification={comparisonNotification} />}
        </Layout.Section>
      )}
      <Layout.Footer>
        <TopHitsLinksContainer />
        <CrosslinksContainer />
        <RenderInViewPort>{(): JSX.Element => <AdfoxSEOBottomBannersLoadable />}</RenderInViewPort>
        <MarkedListContainer />
      </Layout.Footer>
    </Layout>
  );
}
